import React, { useEffect } from "react";
import { useGoogleOneTapLogin } from "react-google-one-tap-login";
import { XANO_GOOGLE_CLIENT_ID } from "../../config/api_config";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getXanoOneTapToken,
  jwtTokenGenerator,
} from "../../redux/actions/authentication";
import { Mixpanel } from "../../config/Mixpanel";
import Constants from "../../common/constants";

const GoogleOneTapLogin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user_id = useSelector((store) => store?.profileDetails?.id);
  const location = useLocation();

  // async function authOneTapResponse(response) {
  //   if (response.error || (response.status && response.status === "unknown")) {
  //     console.log("Auth Failed: ", response.error);
  //   } else {
  //     //console.log(jose);

  //     dispatch(
  //       jwtTokenGenerator(
  //         response,
  //         (jwtToken) => {
  //           dispatch(
  //             getXanoOneTapToken(jwtToken, (successObj) => {
  //               Mixpanel.identify(successObj?.email);
  //               Mixpanel.track(Constants.Mixpanel.LOG_IN, {
  //                 distinct_id: successObj?.email,
  //               });
  //               Mixpanel.people.set({
  //                 $first_name: successObj?.first_name,
  //                 $last_name: successObj?.last_name,
  //               });
  //               if (successObj?.number_verification) {
  //                 navigate(
  //                   location?.state?.from?.pathname
  //                     ? location?.state?.from?.pathname
  //                     : "/courses",
  //                   { replace: true }
  //                 );
  //               } else {
  //                 if (successObj?.show_toast) {
  //                   toast.error(successObj?.message);
  //                 } else {
  //                   navigate("/verification");
  //                 }
  //               }
  //             })
  //           );
  //         },
  //         (errorObj) => {}
  //       )
  //     );
  //   }
  // }

  //  useGoogleOneTapLogin({
  //   onError: (error) => console.log(error),
  //   onSuccess: (response) => {
  //     authOneTapResponse(response);
  //   },
  //   googleAccountConfigs: {
  //     client_id: XANO_GOOGLE_CLIENT_ID,
  //     cancel_on_tap_outside: false,
  //   },
  // });

  useEffect(() => {
    // Load the Google Identity Services script
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    // Initialize the Google Identity Services onload
    script.onload = () => {
      window.google.accounts.id.initialize({
        client_id: XANO_GOOGLE_CLIENT_ID,
        callback: handleCredentialResponse,
        login_uri: window.location.href,
        your_own_param_1_to_login: 'any_value',
        your_own_param_2_to_login: 'any_value',
      });

      // window.google.accounts.id.renderButton(
      //   document.getElementById('buttonDiv'),
      //   { theme: 'outline', size: 'large' } // customization of button
      // );

      window.google.accounts.id.prompt(); // also display the One Tap dialog
    };
  }, []);

function decodeJwtResponse(token){
  let base64Url = token.split(".")[1];
  let base64 = base64Url.replace(/-/g, "+").replace(/_/g,"/");
  let jsonPayLoad = decodeURIComponent(atob(base64).split("").map(function (c){
    return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(""));

  return JSON.parse(jsonPayLoad);
}
  const handleCredentialResponse = (response) => {
    console.log('Friday', response)
       if (response.error || (response.status && response.status === "unknown")) {
      console.log("Auth Failed: ", response.error);
    } else {
      //console.log(jose);
      let responsePayload = decodeJwtResponse(response.credential);
      console.log('Friday' , responsePayload);
      dispatch(
        jwtTokenGenerator(
          responsePayload,
          (jwtToken) => {
            dispatch(
              getXanoOneTapToken(jwtToken, (successObj) => {
                Mixpanel.identify(successObj?.email);
                Mixpanel.track(Constants.Mixpanel.LOG_IN, {
                  distinct_id: successObj?.email,
                });
                Mixpanel.people.set({
                  $first_name: successObj?.first_name,
                  $last_name: successObj?.last_name,
                });
                if (successObj?.number_verification) {
                  navigate(
                    location?.state?.from?.pathname
                      ? location?.state?.from?.pathname
                      : "/courses",
                    { replace: true }
                  );
                } else {
                  if (successObj?.show_toast) {
                    toast.error(successObj?.message);
                  } else {
                    navigate("/verification");
                  }
                }
              })
            );
          },
          (errorObj) => {}
        )
      );
    }
  };

  return <div id="buttonDiv"></div>;
};

export default GoogleOneTapLogin;
